export const PSD2Statuses = {
  typeOfService: {
    IDENTIFICATION_PAYMENT: 'IDENTIFICATION_PAYMENT',
    TRANSACTION_HISTORY: 'TRANSACTION_HISTORY',
    ALL: 'ALL',
  },
  transactionHistory: {
    IN_PROGRESS: 'IN_PROGRESS',
    DOWNLOADED: 'DOWNLOADED',
    ERROR: 'ERROR',
    NAME_SURNAME_MISMATCH: 'NAME_SURNAME_MISMATCH',
    DONE: 'DONE',
  },
  paymentStatus: {
    DONE: 'DONE',
    ERROR: 'ERROR',
    INIT: 'INIT',
  },
  status: {
    NEW: 'NEW',
    IN_PROGRESS: 'IN_PROGRESS',
    EXPIRED: 'EXPIRED',
    ERROR: 'ERROR',
    DONE: 'DONE',
    INIT_ERROR: 'INIT_ERROR',
  },
};

export const PSD2ConsentType = {
  PSD2_DATA_PROCESSING: 'PSD2_DATA_PROCESSING',
  PSD2_DATA_PROCESSING_TRANSACTION_HISTORY:
    'PSD2_DATA_PROCESSING_TRANSACTION_HISTORY',
};

export const EMAIL = 'info@kimbi.cz';

export const PHONE = '225 852 395';
export const PHONE_NO_SPACES = PHONE.replaceAll(' ', '');

export const TIME_HOLIDAY_HOURS = '9:00 — 17:00';
export const TIME_WORKING_END_HOURS = '18:00';

export const SECONDS_TO_WAIT_RESEND = 59;

// Storage keys of the two independent countdowns on the phone verification screen
export const NEW_CODE_TIMER = 'new-code';
export const PHONE_CALL_TIMER = 'phone-call';

export const VCC_LIVE_CHAT = {
  ACCOUNT_ID: '4fcz',
  PROJECT_ID: {
    AUTHENTICATED: 161,
    NON_AUTHENTICATED: 162,
  },
} as const;

// REGEX
export const EMAIL_REGEXP = /^[\w-]([.\w-])*@([\w-]+\.)+[A-Za-z]{2,6}$/;
export const PREFIX_PHONE = '+420';
export const ONLY_NUMBERS_REGEXP = '^[0-9]*$';

export const DASHBOARD_LOGIN = `${import.meta.env.VITE_DASHBOARD_URL}${
  import.meta.env.VITE_DASHBOARD_LOGIN_ROUTE
}`;
